import { useSelector } from 'react-redux';
import { RootState } from '../store';

export function useAppData<T>(fn: (store: RootState) => T): T {
  return useSelector<RootState, T>(fn);
}
